"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncActionsCreator = void 0;
const asyncActionsCreator = (action) => {
    const values = ['SUCCESS', 'FAIL', 'REQUEST'];
    const types = values.reduce((acc, value) => {
        const type = `${action}.${value}`;
        acc[value] = type;
        acc[value.toLowerCase()] = (payload) => ({
            type,
            payload,
        });
        return acc;
    }, {});
    return types;
};
exports.asyncActionsCreator = asyncActionsCreator;
//# sourceMappingURL=WithManipulationActions.js.map